import { doGetRequest, doPostRequest, doPutRequest } from '@its/httpmanager';

export const getTranslations = doGetRequest.bind(null, { url: process.env.translationsApi });
export const getPlugins = doPostRequest.bind(null, { url: 'plugins/all' });
export const getUser = doGetRequest.bind(null, { url: 'auth/GetUserInfo' });
export const getUserRoles = doGetRequest.bind(null, { url: 'auth/UserRoles' });

export const getDepartments = doPostRequest.bind(null, { url: 'Departments/all' });
export const addDepartment = (values) => doPostRequest({ url: 'departments', send: values });
export const modifyDepartment = (values, id) =>
                                doPutRequest({ url: `departments/${id}`, send: values });

export const getDisplays = doPostRequest.bind(null, { url: 'displays/all' });
export const addDisplay = (values) => doPostRequest({ url: 'displays', send: values });
export const modifyDisplay = (id) =>
                             (values) =>
                             doPutRequest({ url: `displays/${id}`, send: values });

export const getTemplates = doPostRequest.bind(null, { url: 'templates/all' });
export const getTemplate = (id) => doGetRequest.bind(null, { url: `templates/${id}` });
export const addTemplate = (values) => doPostRequest({ url: 'templates', send: values });
export const modifyTemplate = (id) =>
                              (values) =>
                              doPutRequest({ url: `templates/${id}`, send: values });

export const getTimers = doPostRequest.bind(null, { url: 'Iterations/all' });
export const getTimer = (id) => doGetRequest.bind(null, { url: `Iterations/${id}` });
export const addTimer = (values) => doPostRequest({ url: 'Iterations', send: values });
export const modifyTimer = (values, id) =>
                           doPutRequest({ url: `Iterations/${id}`, send: values });



/** WEBPACK FOOTER **
 ** ./src/api/index.js
 **/